module.exports = __webpack_public_path__ + "img/6f199df701e24cf29bcba4cc18038578.59dc455c.jpg";